// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J8Fk","content":"styles_content__XsFfo"};